var v1="<div class=\"lbaTabs\" ng-if=\"vm.ready && !vm.dataService.addNewMode\" click-outside=\"vm.clickOutside()\"> <div ng-repeat=\"item in vm.settings.children track by $index\" ng-if=\"vm.activeItem === item.tabName.toLowerCase()\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaTabs/lbaTabs.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaTabs/lbaTabs.html
// module id = 206
// module chunks = 0